import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import useFetchAemBrspdContents from "../../../../../shared/hooks/useFetchAemBrspdContents";
import ApiUrls from "../../../Utils/axr";
import { errorConditionGTM } from "../../../Utils/googleTags";

type applyAcpModalContentDetailsInitialStateType = {
  applyAcpModalPageContent: any;
  loading: boolean;
  error: any;
};
const initialState: applyAcpModalContentDetailsInitialStateType = {
  applyAcpModalPageContent: null,
  loading: false,
  error: null
};
const host = window?.location?.host;
const file = "apply-acp-modal.json";

export const getApplyAcpModalPageContent = createAsyncThunk(
  "get/applyAcpScreen-page/content",
  async () => {
    try {
      const response = await useFetchAemBrspdContents({
        [ApiUrls.aem_content]: `${file}?appName=${host}`,
      });
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);


const applyAcpModalScreenContentDetailSlice = createSlice({
  name: "applyAcpScreen-page/Details",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder.addCase(getApplyAcpModalPageContent.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getApplyAcpModalPageContent.fulfilled, (state, action) => {
      state.applyAcpModalPageContent = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getApplyAcpModalPageContent.rejected, (state, action) => {
      errorConditionGTM(
        "BRSPD_Fiber_EC_Flow",
        "Apply ACP Modal content",
        action.error?.message,
        action?.type
      );
      state.applyAcpModalPageContent = null;
      state.loading = false;
      state.error = action.error;
    });
  },
});
export default applyAcpModalScreenContentDetailSlice.reducer;
